import * as React from 'react'
import styles from './ColorPicker.pcss'
import Popper from '@mui/material/Popper'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Paper from '@mui/material/Paper'
import { ChromePicker } from 'react-color'

interface ColorPickerProps {
  value: string
  className?: string
  btnClassName?: string
  onChange: (color: string) => void
}

export function ColorPicker({ value, className, btnClassName, onChange }: ColorPickerProps) {
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null)

  const onColorChange = (color: any) => {
    onChange(color.hex)
  }

  const openPopup = (e: React.MouseEvent<HTMLElement>) => {
    setAnchor(e.currentTarget)
  }

  const closePopup = () => {
    setAnchor(null)
  }

  return (
    <div className={`${styles.wrapper} ${className || ''}`}>
      <div className={`${styles.btn} ${btnClassName || ''}`} role="button" onClick={openPopup}>
      </div>
      <Popper
        open={Boolean(anchor)}
        anchorEl={anchor}
        disablePortal
        placement="bottom"
        className={styles.popper}
      >
        <ClickAwayListener onClickAway={closePopup}>
          <Paper>
            <ChromePicker color={value} onChange={onColorChange} />
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  )
}
